export const GET_GAMES = "GET_GAMES";
export const GET_GAMES_FULFILLED = "GET_GAMES_FULFILLED";
export const GET_GAMES_PENDING = "GET_GAMES_PENDING";
export const GET_GAMES_REJECTED = "GET_GAMES_REJECTED";

export const GET_R_GAMES = "GET_R_GAMES";
export const GET_R_GAMES_FULFILLED = "GET_R_GAMES_FULFILLED";
export const GET_R_GAMES_PENDING = "GET_R_GAMES_PENDING";
export const GET_R_GAMES_REJECTED = "GET_R_GAMES_REJECTED";

export const GET_GAME_IMAGES = "GET_GAME_IMAGES";
export const GET_GAME_IMAGES_FULFILLED = "GET_GAME_IMAGES_FULFILLED";
export const GET_GAME_IMAGES_PENDING = "GET_GAME_IMAGES_PENDING";
export const GET_GAME_IMAGES_REJECTED = "GET_GAME_IMAGES_REJECTED";